import { authManager } from '@/@core/services/auth/auth';
import { useUserStore } from '@/stores/userStore';

export const kyBeforeRequestValidateTokenInterceptor = async (request: Request) => {
  const userStore = useUserStore();
  if (request.headers.has('authorization') && userStore.isInvalidUserSession()) {
    await authManager.signinRedirect();
  }
  return request;
};
